module.exports = __webpack_public_path__ + "img/4064019880.b9f47c88.jpg";